import * as o from "react";
import s from "../lib/SSRBase.es.js";
import c from "../defs/ArrowCounterClockwise.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(s, { ref: t, ...e, weights: c }));
r.displayName = "ArrowCounterClockwiseIcon";
const m = r;
export {
  m as ArrowCounterClockwise,
  r as ArrowCounterClockwiseIcon
};
